<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-document"></i> 请假审批</span>
      </div>

      <!-- 搜索区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="80px"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <!-- 申请部门 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="申请部门">
              <el-select
                v-model="queryParams.departmentName"
                placeholder="请选择申请部门"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 申请人 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="申请名字">
              <el-input
                v-model="queryParams.creatorName"
                placeholder="请输入申请人名字"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <!-- 请假类型 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="请假类型">
              <el-select
                v-model="queryParams.leaveTypeName"
                placeholder="请选择请假类型"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in leaveTypeList"
                  :key="item.id"
                  :label="item.type"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 审批状态 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="审批状态">
              <el-select
                v-model="queryParams.state"
                placeholder="请选择审批状态"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in stateArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 请假天数 -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="请假天数">
              <el-select
                v-model="queryParams.leaveDays"
                placeholder="请选择请假天数"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="day in [0.5, 1, 1.5, 2, 2.5, 3]"
                  :key="day"
                  :label="day + '天'"
                  :value="day"
                >
                  <i class="el-icon-time"></i> {{ day }}天
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

          <!-- 请假时间 -->
          <el-col :xs="24" :sm="24" :md="8" :lg="6">
            <el-form-item label="请假时间">
              <el-date-picker
                v-model="queryParams.applyTimeRange"
                type="daterange"
                align="right"
                unlink-panels
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 按钮区：独立一行 -->
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button @click="handleExport">导出</el-button>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <!-- 原有列保持不变 -->
        <el-table-column
          prop="departmentName"
          label="申请部门"
          width="150"
          fixed
        ></el-table-column>
        <el-table-column
          prop="creatorName"
          label="申请人"
          width="120"
          fixed
        ></el-table-column>
        <el-table-column
          prop="leaveTypeName"
          label="请假类型"
          width="120"
          fixed
        ></el-table-column>
        <el-table-column
          prop="startTime"
          label="请假开始时间"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="endTime"
          label="请假结束时间"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="leaveReason"
          label="请假原因"
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="leaveDays"
          label="请假时长"
          width="100"
        ></el-table-column>
        <el-table-column prop="state" label="状态" width="120">
          <template slot-scope="scope">
            {{ formatState(scope.row.state).text }}
          </template>
        </el-table-column>
        <!-- 主任审批人 -->
        <el-table-column prop="level1Approver" label="主任" width="120">
          <template slot-scope="scope">
            {{ scope.row.level1Approver || "--" }}
          </template>
        </el-table-column>

        <!-- 分管副园长 -->
        <el-table-column prop="level2Approver" label="分管副园长" width="150">
          <template slot-scope="scope">
            {{ scope.row.level2Approver || "--" }}
          </template>
        </el-table-column>

        <!-- 园长 -->
        <el-table-column prop="level3Approver" label="园长" width="120">
          <template slot-scope="scope">
            {{ scope.row.level3Approver || "--" }}
          </template>
        </el-table-column>
        <el-table-column prop="attachments" label="附件" width="200">
          <template slot-scope="scope">
            <div
              v-if="scope.row.attachments && scope.row.attachments.length > 0"
              style="display: flex; flex-wrap: wrap; gap: 10px"
            >
              <el-image
                v-for="(url, index) in scope.row.attachments"
                :key="index"
                :src="url"
                :preview-src-list="scope.row.attachments"
                style="width: 60px; height: 60px; cursor: pointer"
                fit="cover"
                lazy
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-document"></i>
                </div>
              </el-image>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <!-- 抄送人 -->
        <el-table-column prop="levelCCApprover" label="抄送给" width="150">
          <template slot-scope="scope">
            {{ scope.row.levelCCApprover || "--" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="rejectReason"
          label="驳回信息"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="发起时间"
          width="180"
        ></el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
    </el-card>
  </div>
</template>

<script>
import { leaveApplicationPage, leaveApplicationExport } from "@/api/admin";
import { leaveTypeList } from "@/api/config.js";
import { formatState, downloadFile, parseDateRange } from "@/utils/util";
import PaginationBar from "@/components/PaginationBar";
import { MAX_PAGE_SIZE } from "@/utils/const.js";
import { omit } from "lodash";
import { mapState } from "vuex";

export default {
  name: "LeaveApproval",
  components: { PaginationBar },
  computed: {
    ...mapState(["departmentList"]), // 从 Vuex 获取 userPermissions
  },
  data() {
    return {
      selectedRows: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      // 查询参数
      queryParams: {
        creatorName: "",
        departmentName: "",
        type: "",
        state: "", //审批状态
        leaveDays: undefined,
        applyTimeRange: [], // 新增：用于存储时间范围 [startCreateTime, endCreateTime]
      },
      // 表格数据
      tableData: [],
      stateArr: [
        { id: 0, name: "待审批" },
        { id: 1, name: "审批通过" },
        { id: 2, name: "审批驳回" },
        { id: 3, name: "已取消" },
      ], // 0:待审批，1:审批通过，2:审批驳回 3:取消
      dialogVisible: false,
      dialogTitle: "",
      leaveTypeList: [], // 请假类型
      form: {
        type: "",
        leaveDays: undefined,
        applyTime: "",
        reason: "",
      },
    };
  },
  created() {
    this.handleQuery(1);
    // 请求所有的请假类型
    this.getLeaveTypeList();
  },
  methods: {
    formatState,
    // 请求所有的请假类型
    getLeaveTypeList() {
      leaveTypeList({
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
      }).then((res) => {
        this.leaveTypeList = res.records;
      });
    },
    // 导出方法
    handleExport() {
      const exportData = this.tableData || [];

      if (exportData.length === 0) {
        return this.$message.warning("暂无数据可以导出");
      }

      const { begin_date, end_date } = parseDateRange(
        this.queryParams.applyTimeRange
      );

      const params = omit(this.queryParams, ["applyTimeRange"]);

      leaveApplicationExport({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startCreateTime: begin_date,
        endCreateTime: end_date,
        ...params,
      }).then((res) => {
        downloadFile(
          res.data,
          "请假审批数据.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      const { begin_date, end_date } = parseDateRange(
        this.queryParams.applyTimeRange
      );

      const params = omit(this.queryParams, ["applyTimeRange"]);

      leaveApplicationPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startCreateTime: begin_date,
        endCreateTime: end_date,
        ...params,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    // 重置搜索
    resetQuery() {
      this.queryParams = {
        creatorName: "",
        departmentName: "",
        type: "",
        days: undefined,
      };
      this.handleQuery(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  .el-icon-document {
    margin-right: 5px;
    font-size: 18px;
  }

  .el-table {
    .el-icon-user,
    .el-icon-office-building,
    .el-icon-document,
    .el-icon-time,
    .el-icon-date,
    .el-icon-notebook-2 {
      margin-right: 5px;
    }
  }

  .el-tag {
    .el-icon-check,
    .el-icon-loading,
    .el-icon-close {
      margin-right: 5px;
    }
  }

  .el-button {
    .el-icon-edit,
    .el-icon-delete,
    .el-icon-plus,
    .el-icon-close,
    .el-icon-check {
      margin-right: 5px;
    }
  }

  .el-select {
    .el-icon-document,
    .el-icon-first-aid-kit,
    .el-icon-date,
    .el-icon-time {
      margin-right: 5px;
    }
  }

  .demo-form-inline {
    .el-form-item {
      margin-bottom: 10px;
    }
  }

  .search-buttons {
    margin-bottom: 20px;

    .el-button {
      margin: 0 10px;
    }
  }
}
.el-table__content {
  overflow-x: auto;
}
.el-table {
  &__header-wrapper {
    th {
      background-color: #f5f7fa !important;
      color: #333;
      font-weight: bold;
    }
  }

  &--border,
  &--group {
    border: 1px solid #dcdfe6;
  }

  .cell {
    white-space: nowrap;
  }
}
</style>
